import React, { useState } from 'react';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { CarParkPlanBooking, CarParkSpace } from '@features/whereabouts/services/CarParkingPlanService';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedCarParkSpace, setHoveringCarParkSpace } from "../../../../store/officeView.duck";
import { WithParkingSpaceBooking } from "./WithParkingSpaceBooking";
import { EmptyAvatar } from "../ViewComponents";

export function ParkingSpaceOverlay(props: Props) {
  const {parkingSpace, booking, isSelected} = props;
  const [hover, setHover] = useState(false);
  const dispatch = useDispatch();
  const selectedCarParkSpace = useSelector(selectSelectedCarParkSpace);
  const parkingSpaceBooking = WithParkingSpaceBooking(booking, parkingSpace);

  const onClicked = (e: any) => {
    e.stopPropagation();
    props.onClicked(parkingSpace);
  }

  const onSpaceHover = (isHovering: boolean) => {
    setHover(isHovering);
    if (!selectedCarParkSpace) {
      if (isHovering) {
        dispatch(setHoveringCarParkSpace(parkingSpace));
      } else {
        dispatch(setHoveringCarParkSpace(undefined));
      }
    }
  }

  return (
    <ParkingSpaceContainer id={`parking-space-${parkingSpace.id}`}
                           shadedOut={!parkingSpace.active}
                           x={parkingSpace.x} y={parkingSpace.y}
                           isVisible={hover || isSelected}
                           width={parkingSpace.height}
                           height={parkingSpace.width}
                           rotate={parkingSpace.rotation}
                           onMouseOver={() => onSpaceHover(true)}
                           onTouchStart={() => onSpaceHover(true)}
                           onMouseLeave={() => onSpaceHover(false)}
                           onTouchEnd={() => onSpaceHover(false)}
                           onTouchCancel={() => onSpaceHover(false)}
                           onClick={(e: any) => onClicked(e)}>

      {parkingSpaceBooking.isBooked ? <>
        {parkingSpaceBooking.allDayBooking ? <>
          <UserAvatarAndName firstName={parkingSpaceBooking.allDayBooking.firstName}
                             lastName={parkingSpaceBooking.allDayBooking.lastName}
                             hideName={true}
                             showEditLink={false}
                             colour={"blue"} />
        </> : <>
          <Row>
            {parkingSpaceBooking.amBooking ? <UserAvatarAndName firstName={parkingSpaceBooking.amBooking.firstName}
                                                                lastName={parkingSpaceBooking.amBooking.lastName}
                                                                hideName={true}
                                                                showEditLink={false}
                                                                colour={"blue"} /> : <EmptyAvatar />}
            {parkingSpaceBooking.pmBooking ? <UserAvatarAndName firstName={parkingSpaceBooking.pmBooking.firstName}
                                                                lastName={parkingSpaceBooking.pmBooking.lastName}
                                                                hideName={true}
                                                                showEditLink={false}
                                                                colour={"blue"} /> : <EmptyAvatar />}
          </Row>
        </>}
      </> : <>
        <img src={"/assets/icons/car-front.svg"} alt={""} />
        <span>{parkingSpace.label}</span>
      </>}

      {booking ? <>
      </> : <>
      </>}
    </ParkingSpaceContainer>
  )
}

interface Props {
  parkingSpace: CarParkSpace;
  booking: CarParkPlanBooking[];
  onClicked: (parkingSpace: CarParkSpace) => any;
  isSelected?: boolean;
}


const ParkingSpaceContainer = styled.div<any>`
  width: ${props => `${props.width}px`};
  min-height: ${props => `${props.height}px`};
  border-radius: 3px;
  background-color: ${props => props.shadedOut ? Colours.opaqueMildGrey : Colours.transparent};
  z-index: ${props => props.shadedOut ? 1 : 100};
  position: absolute;
  left: ${props => `${props.x}px`};
  top: ${props => `${props.y}px`};
  border: ${props => props.isVisible ? `3px solid ${Colours.green} !important` : `3px solid ${Colours.darkGrey}`};
  transform: rotate(${props => props.rotate}deg);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: border-color .1s ease-in-out;
  padding: 2px;
  text-align: center;
  overflow: hidden;
  &:hover {
    border: 3px solid ${Colours.darkBlue};
    z-index: 9999;
  }

  .userAvatarAndName p {
    color: white;
  }
  span {
    color: ${props => props.shadedOut ? Colours.darkGrey : Colours.darkBlue};
    font-size: 10px;
    font-style: normal;
    font-family: "soleil", sans-serif;
    font-weight: 700;
    line-height: 12px;
    margin-top: -2px;
  }
  img {
    height: 12px;
    width: 12px;
  }
`

const Row = styled.div`
  display: flex;
  .userAvatarAndName {
    margin: 2px;
  }
`
